import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledNoResult = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  padding: 10px 0;
`;

export function NoResult({ msg }) {
  return <StyledNoResult>{msg}</StyledNoResult>;
}

NoResult.propTypes = {
  msg: PropTypes.string.isRequired
};
